import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import { GameFieldsFragmentDoc } from '../../fragments/__generated__/gameFields.generated';
import { CollectionsPromotionBaseFieldsFragmentDoc } from '../../fragments/__generated__/promotionBaseFields.generated';
import { PromotionTranslationFieldsFragmentDoc } from '../../fragments/__generated__/promotionTranslationFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetBingoPageDataQueryVariables = Types.Exact<{
  language: Types.Scalars['String']['input'];
  pageSlug: Types.Scalars['String']['input'];
  limit: Types.Scalars['Int']['input'];
}>;


export type GetBingoPageDataQuery = { __typename?: 'Query', subNav: Array<{ __typename?: 'Bingo', id: string, translations?: Array<{ __typename?: 'Bingo_translations', slug: string, title: string } | null> | null }>, pageData: Array<{ __typename?: 'Bingo', id: string, translations?: Array<{ __typename?: 'Bingo_translations', slug: string, title: string } | null> | null, carouselData?: { __typename?: 'ItvHeroBannerCarousel', slides?: Array<{ __typename?: 'ItvHeroBannerCarousel_HeroBannerSlides', slideData?: { __typename?: 'HeroBannerSlides', mobile_image?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, desktop_image?: { __typename?: 'directus_files', filename_disk?: string | null, width?: number | null, height?: number | null } | null, translations?: Array<{ __typename?: 'HeroBannerSlides_translations', title?: string | null, subtitle?: string | null, key_terms?: string | null, cta_text?: string | null, cta_link?: string | null, cta_open_in_new_tab?: boolean | null } | null> | null } | null } | null> | null } | null, collections?: Array<{ __typename?: 'Bingo_Collections_1', id: string, Collections_id?: { __typename?: 'Collections', id: string, type: string, layout_type: string, translations?: Array<{ __typename?: 'Collections_translations', title: string, slug?: string | null } | null> | null, games?: Array<{ __typename?: 'Collections_game', game_id?: { __typename?: 'game', game_id?: string | null, id: string, translations?: Array<{ __typename?: 'game_translations', display_name?: string | null, slug?: string | null } | null> | null, game_image?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, game_image_wide?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, game_image_box?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, game_image_tall?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, tags?: Array<{ __typename?: 'game_game_tags', game_tags_id?: { __typename?: 'game_tags', translations?: Array<{ __typename?: 'game_tags_translations', name?: string | null } | null> | null } | null } | null> | null } | null } | null> | null, promotions?: Array<{ __typename?: 'Collections_magicx_promotions', magicx_promotions_id?: { __typename?: 'magicx_promotions', id: string, status?: string | null, internal_name?: string | null, opt_in?: boolean | null, magicx_slug?: string | null, bonus_type?: string | null, DM_Template_ID?: string | null, DM_Max_Amount?: string | null, tag_ID?: string | null, bonus_ID?: string | null, welcome_offer?: boolean | null, start_date?: any | null, start_time?: any | null, end_date?: any | null, end_time?: any | null, translations?: Array<{ __typename?: 'magicx_promotions_translations', title?: string | null, subtitle?: string | null, description?: string | null, eligible_customers?: string | null, how_to_claim?: string | null, terms?: string | null, cta_copy?: string | null, cta_url?: string | null, slug?: string | null, languages_language_code?: { __typename?: 'languages', language_code: string } | null } | null> | null, reg_image_mobile?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, reg_image_desktop?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumb_expanded_mobile?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumb_expanded_desktop?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumb_wide_desktop?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_tall?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, thumbnail_box?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null } | null } | null> | null, bingos?: Array<{ __typename?: 'Collections_bingos', id: string } | null> | null } | null } | null> | null }> };


export const GetBingoPageDataDocument = gql`
    query GetBingoPageData($language: String!, $pageSlug: String!, $limit: Int!) {
  subNav: Bingo(filter: {status: {_eq: "published"}}) {
    id
    translations(
      filter: {languages_language_code: {language_code: {_eq: $language}}}
    ) {
      slug
      title
    }
  }
  pageData: Bingo(
    filter: {status: {_eq: "published"}, translations: {slug: {_eq: $pageSlug}}}
    limit: 1
  ) {
    id
    translations(
      filter: {languages_language_code: {language_code: {_eq: $language}}}
    ) {
      slug
      title
    }
    carouselData: HeroBannerCarousel(filter: {status: {_eq: "published"}}) {
      slides(filter: {HeroBannerSlides_id: {status: {_eq: "published"}}}) {
        slideData: HeroBannerSlides_id {
          mobile_image {
            filename_disk
            width
            height
          }
          desktop_image {
            filename_disk
            width
            height
          }
          translations(
            filter: {languages_language_code: {language_code: {_eq: $language}}}
          ) {
            title
            subtitle
            key_terms
            cta_text
            cta_link
            cta_open_in_new_tab
          }
        }
      }
    }
    collections(filter: {Collections_id: {status: {_eq: "published"}}}) {
      id
      Collections_id {
        id
        type
        layout_type
        translations(
          filter: {languages_language_code: {language_code: {_eq: $language}}}
        ) {
          title
          slug
        }
        games(limit: $limit) {
          game_id {
            ...GameFields
          }
        }
        promotions(limit: $limit) {
          magicx_promotions_id {
            ...CollectionsPromotionBaseFields
            translations(
              filter: {languages_language_code: {language_code: {_eq: $language}}}
            ) {
              ...PromotionTranslationFields
            }
          }
        }
        bingos {
          id
        }
      }
    }
  }
}
    ${GameFieldsFragmentDoc}
${CollectionsPromotionBaseFieldsFragmentDoc}
${PromotionTranslationFieldsFragmentDoc}`;

/**
 * __useGetBingoPageDataQuery__
 *
 * To run a query within a React component, call `useGetBingoPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBingoPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBingoPageDataQuery({
 *   variables: {
 *      language: // value for 'language'
 *      pageSlug: // value for 'pageSlug'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetBingoPageDataQuery(baseOptions: Apollo.QueryHookOptions<GetBingoPageDataQuery, GetBingoPageDataQueryVariables> & ({ variables: GetBingoPageDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBingoPageDataQuery, GetBingoPageDataQueryVariables>(GetBingoPageDataDocument, options);
      }
export function useGetBingoPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBingoPageDataQuery, GetBingoPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBingoPageDataQuery, GetBingoPageDataQueryVariables>(GetBingoPageDataDocument, options);
        }
export function useGetBingoPageDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBingoPageDataQuery, GetBingoPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBingoPageDataQuery, GetBingoPageDataQueryVariables>(GetBingoPageDataDocument, options);
        }
export type GetBingoPageDataQueryHookResult = ReturnType<typeof useGetBingoPageDataQuery>;
export type GetBingoPageDataLazyQueryHookResult = ReturnType<typeof useGetBingoPageDataLazyQuery>;
export type GetBingoPageDataSuspenseQueryHookResult = ReturnType<typeof useGetBingoPageDataSuspenseQuery>;
export type GetBingoPageDataQueryResult = Apollo.QueryResult<GetBingoPageDataQuery, GetBingoPageDataQueryVariables>;